(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["core-home-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('core-home-purchase')) {
  customElements.define('core-home-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const form = this.querySelector('form');
      const button = form.querySelector('[type="submit"]');
      const id = form.querySelector('[name="id"]');
      const sync = () => {
        const chosen = form.querySelector('[name="core_size"]:checked');
        id.value = chosen?.value || '';
        button.disabled = !chosen || chosen.disabled;
        form.querySelector('[name="quantity"]').value = chosen?.dataset.minimum || '1';
        this.querySelector('.core-home-size-hint').hidden = !!chosen;
      };
      form.addEventListener('change', sync, {signal: this.controller.signal});
      form.addEventListener('submit', event => {
        const chosen = form.querySelector('[name="core_size"]:checked');
        if (!chosen || chosen.disabled || id.value !== chosen.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.querySelector('[name="core_size"]:not(:disabled)')?.focus();
        }
      }, {signal: this.controller.signal, capture: true});
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["core-product-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('core-product-video'))customElements.define('core-product-video',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
    this.querySelector('.core-video-poster')?.addEventListener('click',()=>{
      if(!this.video){this.append(this.querySelector('template').content.cloneNode(true));this.video=this.querySelector('video');this.video.muted=true;this.video.defaultMuted=true;this.video.removeAttribute('autoplay');this.querySelector('.core-video-poster').hidden=true;this.querySelector('.core-video-poster').style.display='none';}
      this.video.play().catch(()=>{});
    },{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video?.pause();},{signal});
    this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.video?.pause();},{threshold:0.1});this.observer.observe(this);
  }
  disconnectedCallback(){this.video?.pause();this.controller?.abort();this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('core-gallery-dots')) {
  customElements.define('core-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      clearTimeout(this.transitionTimer);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.playButton?.remove();
    }
    setup() {
      if (!this.closest('[data-core-slider]')) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const viewer = this.closest('slider-component');
      const track = viewer.querySelector('.product__media-list');
      const slides = Array.from(track.children);
      const enhanced = !!this.closest('product-info:is([data-core-refinements], [data-core-home-gallery])');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.index = 0;
      this.replaceChildren();
      const position = (index) => slides[index].offsetLeft - slides[0].offsetLeft;
      const update = () => {
        let closest = 0;
        slides.forEach((slide, index) => {
          if (Math.abs(position(index) - track.scrollLeft) < Math.abs(position(closest) - track.scrollLeft)) closest = index;
        });
        slides.forEach((slide,index)=>{if(index!==closest)slide.querySelectorAll('video').forEach(video=>video.pause());});
        if(slides[closest]?.querySelector('core-product-video'))clearTimeout(this.timer);
        this.index = closest;
        Array.from(this.children).forEach((button, index) => button.setAttribute('aria-current', String(index === closest)));
        if (enhanced) slides.forEach((slide, index) => {
          slide.inert = index !== closest;
          slide.classList.toggle('is-active', index === closest);
        });
      };
      const restart = () => {
        clearTimeout(this.timer);
        if (!enhanced || slides.length < 2 || this.paused || this.motion.matches || document.hidden || this.touching || slides[this.index]?.querySelector('core-product-video')) return;
        this.timer = setTimeout(() => {
          if (document.querySelector('product-modal[open]')) { restart(); return; }
          go(this.index + 1);
        }, 3000);
      };
      const go = (index) => {
        const next = (index + slides.length) % slides.length;
        slides.forEach(slide=>slide.querySelectorAll('video').forEach(video=>video.pause()));
        clearTimeout(this.transitionTimer);
        if (enhanced && !this.motion.matches && Math.abs(next - this.index) > 1) {
          track.style.opacity = '0';
          this.transitionTimer = setTimeout(() => {
            track.scrollTo({left: position(next), behavior: 'instant'});
            track.style.opacity = '1';
          }, 160);
        } else {
          track.style.opacity = '1';
          track.scrollTo({left: position(next), behavior: this.motion.matches ? 'instant' : 'smooth'});
        }
        restart();
      };
      slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        if(slide.querySelector('core-product-video')){button.classList.add('core-video-thumbnail');button.title='Play video';}
        button.setAttribute('aria-label', this.dataset.label.replace('[index]', index + 1));
        button.setAttribute('aria-controls', track.id);
        button.addEventListener('click', () => go(index), {signal});
        this.append(button);
      });
      track.addEventListener('scroll', update, {signal, passive: true});
      if (enhanced && slides.length > 1) {
        viewer.enableSliderLooping = true;
        ['previous', 'next'].forEach((name) => {
          const arrow = viewer.querySelector(`button[name="${name}"]`);
          arrow.removeAttribute('disabled');
          arrow.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            go(this.index + (name === 'next' ? 1 : -1));
          }, {signal, capture: true});
        });
        this.playButton = document.createElement('button');
        this.playButton.type = 'button';
        this.playButton.className = 'core-gallery-play';
        const updatePlay = () => {
          this.playButton.hidden = this.motion.matches;
          this.playButton.style.display = this.motion.matches ? 'none' : '';
          this.playButton.textContent = this.paused ? '▶' : 'Ⅱ';
          this.playButton.setAttribute('aria-label', this.paused ? window.accessibilityStrings.playSlideshow : window.accessibilityStrings.pauseSlideshow);
        };
        this.playButton.addEventListener('click', () => {
          this.paused = !this.paused;
          updatePlay();
          restart();
        }, {signal});
        this.after(this.playButton);
        updatePlay();
        document.addEventListener('visibilitychange', restart, {signal});
        this.motion.addEventListener('change', () => { updatePlay(); restart(); }, {signal});
        track.addEventListener('pointerdown', () => { this.touching = true; clearTimeout(this.timer); }, {signal, passive: true});
        const release = () => { this.touching = false; restart(); };
        window.addEventListener('pointerup', release, {signal, passive: true});
        window.addEventListener('pointercancel', release, {signal, passive: true});
        this.resizeObserver = new ResizeObserver(() => {
          track.scrollTo({left: position(this.index), behavior: 'instant'});
          viewer.resetPages?.();
        });
        this.resizeObserver.observe(track);
      }
      update();
      if (slides.length < 2) viewer.querySelector('.slider-buttons').style.setProperty('display', 'none', 'important');
      viewer.resetPages?.();
      restart();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
